import styled from "@emotion/styled";
import { Image } from "antd";
import { FC, useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Bread } from "../../common/component/Bread";
import { ImageFill } from "../../common/component/ImageFill";
import { RightArrows } from "../../common/component/RightArrows";
import { ProductEntity } from "../../module/product/entity/product.entity";
import { TypeEntity } from "../../module/product/entity/type.entity";
import { getProductList } from "../../module/product/service/product.service";
import { getTypeDetail } from "../../module/product/service/type.service";

export const TypeDetail: FC = () => {
	const [info, setInfo] = useState<TypeEntity>({});
	const [productArr, setProductArr] = useState<ProductEntity[]>([]);

	const { id } = useParams();
	const navigate = useNavigate();

	const init = useCallback(async () => {
		const { data } = await getTypeDetail(Number(id));
		setInfo(data);
		const productRes = await getProductList({ typeId: Number(id) });
		setProductArr(productRes.data);
	}, [id]);

	useEffect(() => {
		window.scrollTo(0, 0);
		init();
	}, [init]);

	const breadArr = [
		{
			title: "产品相关",
			link: "/products",
		},
		{
			title: info.title,
		},
	];

	return (
		<Container>
			<ImageFill src={info.image ?? ""} width={1600} height={500} areaHeight={296} />
			<div className='content'>
				<div className='page-title'>
					<h1>{info.title ?? ""}</h1>
				</div>
				<Bread value={breadArr} />
				<div className='products'>
					{info.userComments && (
						<div className='user col-lg-4 col-md-6 col-xs-12'>
							<div className='title'>{info.userComments}</div>
							<div className='img'>
								<Image src={info.userImage} preview={false} />
							</div>
						</div>
					)}
					{productArr &&
						productArr.map((item, index) => {
							return (
								<>
									{((info.userComments && index === 0) || index === 2) && <div key={`key${index}`} className='product col-lg-4 col-md-6 col-xs-12' />}
									<div key={index} className='product col-lg-4 col-md-6 col-xs-12' onClick={() => navigate(`/product/${item.id}`)}>
										<Image src={item.image} preview={false} />
										<div className='title'>{item.title}</div>
										<div>{item.description?.replace(/<[^>]+>/g, "").replaceAll("&nbsp;", '')} </div>
									</div>
								</>
							);
						})}
				</div>

				{info.industryIds && (
					<div className='industries'>
						<h2>{info.title}应用行业</h2>
						<div className='list'>
							{info.industryArr?.map((item, index) => {
								return (
									<div className='item col-lg-2 col-md-3 col-xs-6' key={index}>
										<div>
											<Image src={item.image} preview={false} />
										</div>
										<div className='title'>{item.title}</div>
									</div>
								);
							})}
						</div>
					</div>
				)}

				{info.successStoryIds && (
					<div className='successStories'>
						<Image className='bgImg' src={info.successStoryImage} preview={false} />
						<div className='title'>成功案例</div>
						<div className='list'>
							{info.successStoryArr &&
								info.successStoryArr.map((item, index) => {
									const length = info.successStoryArr?.length ?? 1;
									const lgLength = Math.floor(9 / length);
									return (
										<div className={`item col-lg-${lgLength} col-md-5 col-xs-12`} key={index}>
											<Image src={item.image} preview={false} width='100%' />
											<h2>{item.title}</h2>
											<div dangerouslySetInnerHTML={{ __html: item.description ?? "" }} />
											{item.productArr &&
												item.productArr.map((item1, index1) => {
													return (
														<div className='productLink' key={index1} onClick={() => navigate(`/product/${item1.id}`)}>
															<div>
																<span>产品：</span>
																<b>{item1.title}</b>
															</div>
															<div>
																<RightArrows />
															</div>
														</div>
													);
												})}
										</div>
									);
								})}
						</div>
					</div>
				)}
			</div>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;
	background-color: #fff;

	.content {
		margin: -7em auto 0;
		background: white;
		padding: 1em;
		z-index: 10;
		position: relative;

		.products {
			display: flex;
			justify-content: left;
			flex-wrap: wrap;
			position: relative;
			min-height: 360px;
			margin: 0 -1rem 2rem -1rem;

			.user {
				width: 380px;
				min-width: 30%;
				height: 350px;
				position: absolute;
				left: 15px;
				background-color: #004885;
				margin-right: 15px;
				z-index: 99;

				.title {
					width: 60%;
					margin: 2rem 0 0 2rem;
					color: #fff;
					font-size: 1.8rem;
				}

				.img {
					.ant-image {
						width: 170px;
						height: 250px;
						position: absolute;
						bottom: -20px;
						right: -20px;
					}
				}
			}

			@media (max-width: 544px) {
				.user {
					display: none;
				}
			}

			.product {
				padding: 0 1rem 0 0;
				font-size: 0.75rem;
				color: #004885;
				margin-bottom: 0.5rem;
				cursor: pointer;

				.title {
					font-weight: 700;
					font-size: 0.9rem;
					line-height: 2rem;
				}
			}
		}

		.industries {
			margin-bottom: 2rem;

			.list {
				display: flex;
				justify-content: left;
				flex-wrap: wrap;

				.item {
					margin-right: 1rem;
					margin-top: 0.5rem;
					.title {
						background-color: #004885;
						color: #fff;
						line-height: 2.2rem;
						text-align: center;
						overflow: hidden;
						height: 2.2rem;
					}

					img {
						width: 100%;
					}
				}
			}
		}

		.successStories {
			position: relative;

			.title {
				background-color: #fff;
				color: #004885;
				font-size: 2rem;
				position: absolute;
				left: 0;
				top: 0;
				padding: 1rem 2rem;
				font-weight: 600;
			}

			.list {
				position: absolute;
				top: 6rem;
				display: flex;
				justify-content: space-around;
				.item {
					background-color: #fff;
					padding: 1rem;

					.productLink {
						border: 1px solid #ccc;
						padding: 1rem;
						display: flex;
						justify-content: space-between;
						color: #004885;
						cursor: pointer;
					}
				}
			}
		}
	}

	@media (max-width: 544px) {
		.content {
			.successStories {
				.bgImg {
					display: none;
				}

				.title, .list {
					position: relative;
					top: 0;
				}
			}
		}
	}
`;
